<div class="fw-ThirdLevelMobile_menu" *ngIf="!grandChild && child && child.children">
    <ng-container *ngFor="let thirdLevel of child.children">
        <div *ngIf="!thirdLevel.hideFromNavigation" class="fw-ThirdLevelMobile_menu-Items">
            <div *ngIf="thirdLevel.istitle=='true'; else noTitle" class="fw-ThirdLevelMobile_menu-Item">
                {{ thirdLevel.name | pershingTranslate}}
            </div>
            <ng-template #noTitle>
                <div id="nav-{{thirdLevel.id}}" href="javascript:void(0);"
                    (click)="handleThirdLevelNavigation(thirdLevel)"
                    class="fw-ThirdLevelMobile_menu-Item">
                    {{ thirdLevel.name | pershingTranslate}}
                    <span class="far fa-chevron-right fw-ThirdLevelMobile_menu-Icon"></span>
                </div>
            </ng-template>
        </div>
    </ng-container>
</div>

<div *ngIf="grandChild && !grandChild.hideBack" class="fw-ThirdLevelMobile_Backbtn">
    <span (click)="handleBackNavigation()">
        <div class="far fa-chevron-left fw-ThirdLevelMobile_Backbtn-Icon"></div>
        <span class="fw-ThirdLevelMobile_Backbtn-Text">{{ 'NXI_NAVIGATION.BACK' | pershingTranslate}}</span>
    </span>
</div>
